import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseSubscriberChannelComponent } from '../../abstract-components/base-subscriber-channel.component';

@Component({
  selector: 'subscriber-channel-layout',
  standalone: false,
  templateUrl: './subscriber-channel-layout.component.html',
  styleUrl: './subscriber-channel-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubscriberChannelLayoutComponent extends BaseSubscriberChannelComponent {}
